import {DOM} from "../../../../public/js/utils/DOM";
import {Networking} from "../../../../public/js/utils/Netwtorking";
import {LinkBuilder} from "../../../../public/js/utils/LinkBuilder";
import Swal from "sweetalert2";
import {CustomFunctions} from "../../../../public/js/elements/customFunctions";
import {Toggles} from "../../../../public/js/utils/Toggles";
import {Notify} from "../../../../public/js/utils/Notify";
import {RequestTypes} from "../../../../public/js/definitions/utils/networking/RequestTypes";
import {ControlsGeneralSideNavControl} from "../SideNavControl/SideNavControl";

export namespace ControlsGeneralMenuTopControl {

    class Config {
        public static readonly component: string = 'menuTop';
        public static readonly loadUnreadMessagesBackendCallback: string = 'loadUnreadMessages';
        public static readonly loadUnreadTicketsBackendCallback: string = 'loadActiveTickets';
        public static readonly loadOverdueInvoicesBackendCallback: string = 'loadOverdueInvoices';
        public static readonly toggleDesktopElementId: string = "MenuTopControl-user-toggle";
        public static readonly showMobileElementId: string = "MenuTopControl-mobileMenu-show";
        public static readonly hideMobileElementId: string = "MenuTopControl-mobileMenu-hide";
        public static readonly dropDownElementId: string = "MenuTopControl-user-dropdown";
        public static readonly shownClassName: string = "shown";
        public static readonly actualizeTriggerElementId: string = "MenuTopControl-user-drop-top-item-actualize";
        public static readonly actualizeCacheBackendCallback = "actualize";
        public static readonly supportPasswordTriggerElementId = "MenuTopControl-user-drop-top-item-support";
        public static readonly supportPasswordBackendCallback = "Support";
        public static readonly showSideNavTriggerElementId = "MenuTopControl-sideNav-show";
        public static readonly invoicesBlockSelector: string = ".MenuTopControl-items-item.invoices";
        public static readonly ticketsBlockSelector: string = ".MenuTopControl-items-item.tickets";
        public static readonly messagesBlockSelector: string = ".MenuTopControl-items-item.messages";
        public static readonly jsTranslationsElementId : string = "jsTranslations";
        public static readonly jsTranslationsSupportPassword : string = "trsSupportPassword";
        public static readonly supportPasswordModalTriggerChangeUrlDataName = "link";
    }

    export class Control {

        static triggerToggleMenu() {

            this.triggerDesktopToggle();
            this.triggerMobileShow();
            this.triggerMobileHide();
            if (document.querySelector(Config.messagesBlockSelector)) { this.loadUnreadMessages(false); }
            if (document.querySelector(Config.ticketsBlockSelector)) { this.loadActiveTickets(false); }
            if (document.querySelector(Config.invoicesBlockSelector)) { this.loadOverdueInvoices(false); }
            this.triggerCacheRefresh();
            this.triggerSupportPassword();
            this.triggerMobileShowSideNav();
            this.triggerHideOnOutsideClick();
        }

        private static triggerHideOnOutsideClick() : void {

            window.addEventListener('click', (evt: MouseEvent) => {

                if (!this.checkMenuOpened()) { return; }
                const clickedInside = DOM.Parser.parentContainsTheClass('MenuTopControl-user-dropdown', evt.target as HTMLElement);
                if (clickedInside) { return; }
                this.doDesktopToggle();
            });
        }

        private static checkMenuOpened(): boolean {
            return DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.contains(Config.shownClassName);
        }

        /**
         * Actualize cache, send request to remove it
         * Refresh page to load new data on success
         */
        private static triggerCacheRefresh() : void {

            DOM.Parser.getHtmlElement(Config.actualizeTriggerElementId).addEventListener('click', (event: MouseEvent) => {

                event.stopPropagation();
                event.preventDefault();

                const jsTranslations = DOM.Parser.getHtmlElement("jsTranslations");
                const modalTitle = DOM.Parser.getDataByNameFromElement("trsSweetalertCacheTitle", jsTranslations);
                const modalText = DOM.Parser.getDataByNameFromElement("trsSweetalertCacheText", jsTranslations);
                const modalYes = DOM.Parser.getDataByNameFromElement("trsSweetalertYes", jsTranslations);
                const modalNo = DOM.Parser.getDataByNameFromElement("trsSweetalertNo", jsTranslations);

                DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.remove(Config.shownClassName);

                Swal.fire({
                    title: modalTitle,
                    html: modalText,
                    imageUrl: '/resources/images/2023/authInfographic.avif',
                    buttonsStyling: false,
                    confirmButtonText: modalYes,
                    cancelButtonText: modalNo,
                    showCancelButton: true})
                    .then((result) => {
                        if (result.value) {
                            void Networking.NetworkingController.createRequest({
                                type: RequestTypes.GET,
                                successCallback: () => {
                                    setTimeout(() => {
                                        document.location.reload();
                                    }, 1000);
                                },
                                url: LinkBuilder.LinkBuilderController.composeLink({

                                    component: Config.component,
                                    method: Config.actualizeCacheBackendCallback,
                                    parameters: []
                                }),
                            });
                        }
                    });
            });
        }

        /**
         * Support password functionality
         * @private
         */
        private static triggerSupportPassword() : void {

            if (!document.getElementById(Config.supportPasswordTriggerElementId)) { return; }
            const trigger = DOM.Parser.getHtmlElement(Config.supportPasswordTriggerElementId);
            trigger.addEventListener('click', (event: MouseEvent) => {

                event.preventDefault(); event.stopPropagation();
                DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.remove(Config.shownClassName);

                void Networking.NetworkingController.createRequest({
                    type: RequestTypes.GET,
                    dontProcessPayload: true,
                    url: LinkBuilder.LinkBuilderController.composeLink({
                        component: Config.component, method: Config.supportPasswordBackendCallback, parameters: [],
                    }),
                    successCallback: (result: any) => {

                        const notify = Notify.Handler.getMessageFromPayload(result);
                        const pass = notify?.message ?? null;

                        // Translations
                        const transElem = DOM.Parser.getHtmlElement(Config.jsTranslationsElementId);
                        const msgCopy = DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordCopy', transElem);
                        const msgCopied = DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordCopied', transElem);
                        const changePassText = DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordChangeText', transElem);
                        const changePassUrl = DOM.Parser.getDataByNameFromElement(Config.supportPasswordModalTriggerChangeUrlDataName, trigger);
                        const emptyHint = DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordEmptyHint', transElem);
                        const errorHint = DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordErrorHint', transElem);
                        const supportPasswordTitle = DOM.Parser.getDataByNameFromElement(Config.jsTranslationsSupportPassword, transElem);

                        let dialogHTML;
                        if (notify === null || notify.type === "error") {
                            dialogHTML = `\
                                <div class="supportPassBox error">\
                                    <div class="supportPassBox-box box"></div>\
                                    <div class="supportPassBox-hint hint">${errorHint}</div>\
                                </div>`;
                        } else if (notify?.type === "info") {
                            dialogHTML = `\
                                <div class="supportPassBox empty">\
                                    <div class="supportPassBox-box box">${pass}</div>\
                                    <div class="supportPassBox-hint hint">${emptyHint}</div>\
                                </div>`;
                        }
                        else {
                            dialogHTML = `\
                                <div class="supportPassBox">\
                                    <div class="supportPassBox-box box">${pass}</div>\
                                    <div class="swal2-buttons">\
                                        <button class="btn btn-blue" id="btn-copytoclipboard" data-pass="${pass}">${msgCopy}</button>\
                                        <a class="btn btn-green" href="${changePassUrl}">${changePassText}</a>\
                                    </div>
                                </div>`;
                        }

                        // Show support password
                        void Swal.fire({
                            imageUrl: '/resources/images/2023/authInfographic.avif',
                            title: supportPasswordTitle,
                            html: dialogHTML,
                            showCloseButton: true,
                            padding: '2.25em',
                            buttonsStyling: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            didOpen: function() {
                                if (notify !== null && notify.type === "success" && pass !== null) {
                                    const copyButton = DOM.Parser.getHtmlElement('btn-copytoclipboard') as HTMLButtonElement;
                                    copyButton.addEventListener('click', () => {
                                        CustomFunctions.controlFunctions.copyToClipBoard(pass);
                                        Notify.Handler.processMessages([{message: msgCopied, type: "success", closeModal: false, uniqKeys: null, eventId: null}])
                                    });
                                }
                            }
                        });
                    },
                });
            });
        }

        public static loadUnreadMessages(fresh: boolean) {

            if (!Toggles.Handler.toggleAvailable('MENU_COUNTS')) { return; }

            void Networking.NetworkingController.createRequest({
                type: RequestTypes.POST,
                data: {fresh: fresh},
                url: LinkBuilder.LinkBuilderController.composeLink({

                    component: Config.component,
                    method: Config.loadUnreadMessagesBackendCallback,
                    parameters: []
                }),
            });
        }

        public static loadOverdueInvoices(fresh: boolean) {

            if (!Toggles.Handler.toggleAvailable('MENU_COUNTS')) { return; }

            void Networking.NetworkingController.createRequest({
                type: RequestTypes.POST,
                data: {fresh: fresh},
                url: LinkBuilder.LinkBuilderController.composeLink({

                    component: Config.component,
                    method: Config.loadOverdueInvoicesBackendCallback,
                    parameters: []
                }),
            });
        }

        public static loadActiveTickets(fresh: boolean) {

            if (!Toggles.Handler.toggleAvailable('MENU_COUNTS')) { return; }

            void Networking.NetworkingController.createRequest({
                type: RequestTypes.POST,
                data: {fresh: fresh},
                url: LinkBuilder.LinkBuilderController.composeLink({

                    component: Config.component,
                    method: Config.loadUnreadTicketsBackendCallback,
                    parameters: []
                }),
            });
        }

        private static triggerDesktopToggle() {

            const trigger = DOM.Parser.getHtmlElement(Config.toggleDesktopElementId);
            trigger.addEventListener('click', (event: MouseEvent) => {

                event.stopPropagation();
                event.preventDefault();
                this.doDesktopToggle();
            });
        }

        private static doDesktopToggle() : void {

            const trigger = DOM.Parser.getHtmlElement(Config.toggleDesktopElementId);
            trigger.classList.toggle(Config.shownClassName);
            DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.toggle(Config.shownClassName);
        }

        private static triggerMobileShow() {

            const trigger = DOM.Parser.getHtmlElement(Config.showMobileElementId);
            trigger.addEventListener('click', (event: MouseEvent) => {

                event.stopPropagation();
                event.preventDefault();
                trigger.classList.add(Config.shownClassName);
                DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.add(Config.shownClassName);
            });
        }

        private static triggerMobileHide() {

            const trigger = DOM.Parser.getHtmlElement(Config.hideMobileElementId);
            trigger.addEventListener('click', (event: MouseEvent) => {

                event.stopPropagation();
                event.preventDefault();
                trigger.classList.remove(Config.shownClassName);
                DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.remove(Config.shownClassName);
            });
        }

        private static triggerMobileShowSideNav() {

            const trigger = DOM.Parser.getHtmlElement(Config.showSideNavTriggerElementId);
            trigger.addEventListener('click', (event: MouseEvent) => {

                event.stopPropagation();
                event.preventDefault();
                ControlsGeneralSideNavControl.Control.actionShowMenu();
            });
        }
    }
}